import { Images } from '../../utils/images.utils';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'dp-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
    public arrow = Images.ARROW;
    public name = 'Rafael Rodrigo Fazolli';
    public initials: string;

    public ngOnInit() {
        this.getInitialWord();
    }

    public getInitialWord() {
        const names = this.name.match(/\b\w/g);
        this.initials = (names.shift() + names.pop()).toUpperCase();
    }
}
